import { NctsPhase } from '../../../shared/ncts/types'

export const TRANSIT_OPERATION_KEY = 'transit-operation'

/**
 * The transit list and the remaining legacy queries under `routes/phase5` are still
 * keyed by the URL path rather than by the domain key above.
 */
export const LEGACY_TRANSIT_OPERATION_KEY = '/v2/transit-operation'

export const transitOperationCacheRoots = [
  [TRANSIT_OPERATION_KEY],
  [LEGACY_TRANSIT_OPERATION_KEY],
] as const

export const transitOperationQueryKeys = {
  all: [TRANSIT_OPERATION_KEY] as const,
  details: () => [...transitOperationQueryKeys.all, 'detail'] as const,
  detailById: (params: { id: number | null }) => [...transitOperationQueryKeys.details(), params.id] as const,
  detail: (
    params: { id: number | null; isEns: boolean },
  ) => [...transitOperationQueryKeys.detailById({ id: params.id }), { isEns: params.isEns }] as const,
  validations: () => [...transitOperationQueryKeys.all, 'validation'] as const,
  validation: (params: {
    transitOperationId: number | null
    params?: {
      phase: NctsPhase
      scope?: string
    }
  }) => [...transitOperationQueryKeys.validations(), params] as const,
  guaranteeCalculations: () => [...transitOperationQueryKeys.all, 'guarantee-calculation'] as const,
  guaranteeCalculation: (
    params: { transitOperationId: number | null; exchangeRate: number },
  ) => [...transitOperationQueryKeys.guaranteeCalculations(), params] as const,
}
